// src/api/auth.ts
import request, { type ApiRequestConfig } from '@/utils/request'
const baseUrl = import.meta.env.VITE_API_BASE_URL

export const authApi = {
  changePassword(data: { currentPassword: string; newPassword: string; confirmPassword: string }) {
    return request.post('/api/Auth/ChangePassword', data, {
      skipErrorAlert: true,
      withCredentials: true,
    } as ApiRequestConfig)
  },
  /**
   * 呼叫後端登入 API
   */
  login(loginData: unknown) {
    return fetch(`${baseUrl}/api/Auth/Login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(loginData),
    })
  },
  refresh() {
    return fetch(`${baseUrl}/api/Auth/Refresh`, { method: 'POST', credentials: 'include' })
  },
  logout() {
    return fetch(`${baseUrl}/api/Auth/Logout`, { method: 'POST', credentials: 'include' })
  },
}
